import { useEffect } from 'react';

const useCustomCursor = () => {
  useEffect(() => {
    const handleMouseDown = () => {
      document.body.classList.add('click-cursor');
    };

    const handleMouseUp = () => {
      document.body.classList.remove('click-cursor');
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);
};

export default useCustomCursor;